/**
 * Styles for the dues tray portal (backdrop + drawer panel).
 * Fork of cart-drawer-styles without the floating trigger badge (#179 deferred).
 *
 * Z-index contract (shared across seva-components portal overlays):
 *   10000     modal backdrop        (seva-event-register-modal)
 *   10001     modal panel
 *   10100     drawer backdrop       (cart + dues tray)
 *   10101     drawer panel
 *   10102     Stripe checkout body mount (Option B)
 */
export const duesTrayStyles = `
	:host {
		--_primary: var(--seva-primary-color, #18181b);
		--_primary-hover: var(--seva-primary-hover-color, #27272a);
		--_radius: var(--seva-border-radius, 0.5rem);
		--_font: var(--seva-font-family, system-ui, -apple-system, sans-serif);
		--_bg: var(--seva-bg-color, #ffffff);
		--_text: var(--seva-text-color, #18181b);
		--_text-muted: var(--seva-text-muted-color, #71717a);
		--_border: var(--seva-border-color, #e4e4e7);

		font-family: var(--_font);
		color: var(--_text);
	}

	:host([data-theme="dark"]) {
		--_primary: var(--seva-primary-color, #f4f4f5);
		--_primary-hover: var(--seva-primary-hover-color, #e4e4e7);
		--_bg: var(--seva-bg-color, #18181b);
		--_text: var(--seva-text-color, #f4f4f5);
		--_text-muted: var(--seva-text-muted-color, #a1a1aa);
		--_border: var(--seva-border-color, #3f3f46);
	}

	.backdrop {
		position: fixed;
		inset: 0;
		z-index: 10100;
		background: rgba(0,0,0,0.5);
		opacity: 0;
		visibility: hidden;
		transition: opacity 200ms ease, visibility 200ms ease;
	}

	.backdrop.open {
		opacity: 1;
		visibility: visible;
		transition-duration: 300ms;
	}

	.drawer {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		z-index: 10101;
		width: 420px;
		max-width: 90vw;
		background: var(--_bg);
		box-shadow: -4px 0 24px rgba(0,0,0,0.12);
		display: flex;
		flex-direction: column;
		transform: translateX(100%);
		transition: transform 200ms cubic-bezier(0.32, 0.72, 0, 1);
	}

	.drawer.open {
		transform: translateX(0);
		transition-duration: 300ms;
	}

	.drawer-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 1rem 1.25rem;
		border-bottom: 1px solid var(--_border);
		flex-shrink: 0;
	}

	.drawer-title {
		font-size: 20px;
		font-weight: 600;
		margin: 0;
	}

	.close-btn {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		border: none;
		background: transparent;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		color: var(--_text-muted);
		font-size: 1.25rem;
		padding: 0;
		transition: background 0.15s;
		font-family: var(--_font);
	}

	.close-btn:hover {
		background: color-mix(in srgb, var(--_border) 40%, transparent);
	}

	.drawer-body {
		flex: 1;
		overflow-y: auto;
		overscroll-behavior: contain;
		padding: 0;
	}

	.drawer.checkout-active .drawer-body {
		display: flex;
		flex-direction: column;
		flex: 1;
		min-height: 0;
		overflow: hidden;
	}

	.drawer.checkout-active .drawer-body > seva-dues-flow,
	.drawer.checkout-active .drawer-body > seva-cart {
		flex: 1;
		min-height: 0;
		display: flex;
		flex-direction: column;
	}

	.drawer-body seva-dues-flow {
		display: block;
	}

	@media (max-width: 639px) {
		.drawer {
			top: auto;
			left: 0;
			right: 0;
			bottom: 0;
			width: 100%;
			max-width: 100%;
			max-height: 85vh;
			border-radius: 1rem 1rem 0 0;
			transform: translateY(100%);
		}

		.drawer.open {
			transform: translateY(0);
		}

		.drawer.checkout-active {
			height: 85vh;
			max-height: 85vh;
			height: 85dvh;
			max-height: 85dvh;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.backdrop,
		.drawer {
			transition: none !important;
		}
	}
`;
